/**
 * Omits the given keys from the object
 * @example - omit({ a: 1, b: 2, c: 3 }, ['a', 'c']) // { b: 2 }
 */
export const omit = <T extends Record<string, unknown>, K extends keyof T>(
  object: T,
  keys: K[]
): Omit<T, K> => {
  const result = { ...object };
  for (const key of keys) {
    delete result[key];
  }
  return result;
};
